import { chartType } from '../../types'

export default [
  {
    title: chartType.bar,
    desc: '123123123',
    charts: [
      { name: 'bar', img: 'bar.webp' },
      { name: 'custom', img: 'custom.webp' }
    ]
  },
  {
    title: chartType.line,
    desc: '123123123',
    charts: [{ name: 'line', img: 'line.webp' }]
  },
  {
    title: chartType.pie,
    desc: '123123123',
    charts: [{ name: 'pie', img: 'pie.webp' }]
  }
]
